import React, {useState} from 'react'
import { toast } from 'react-toastify';
import authService from '../authentication';
import MitigationEffectRadio from './MitigationEffectRadio';
import YearsSelector from './YearsSelector';

const MitigationModalContent = ({pModel,
                                 ITEMS_PER_PAGE, 
                                 currentPage, 
                                 setCurrentPage,
                                 currentItems, 
                                 startIndex, 
                                 checkedState, 
                                 setCheckedState,
                                 errors, 
                                 radioState,
                                 setRadioState,
                                 validatePage,
                                 submitMitigationEffectHandler,
                                 
                                 }) => {

    const totalPages = Math.ceil(pModel?.schema.length / ITEMS_PER_PAGE);

    const effectiveness = ["High", "Medium", "Low"];
    const confidence = ["Very", "moderately", "Unsure"];


    const handleCheckboxChange = (index) => {
        setCheckedState((prev) => ({
        ...prev,
        [index]: !prev[index],
        }));
    };

    const handleRadioChange = (key, value) => {
        setRadioState((prev) => ({
            ...prev,
            [key]: value,
        }));
    };


    // Selecting number of years the mitigation holds
    
    return (
        <div className="w-full">
            {/* Slide Content */}
            <div className="space-y-6 max-h-[500px] overflow-y-auto pr-2 scroll-smooth scrollbar-thin scrollbar-thumb-purple-400">
                {currentItems.map((s, index) => {
                const globalIndex = startIndex + index;
                return (
                    <div key={globalIndex} className="mb-4">
                    {/* Checkbox + Criteria */}
                    <label className="flex items-center gap-3 cursor-pointer">
                        <div className="flex justify-center basis-[2%]">
                        <input
                            type="checkbox"
                            checked={!!checkedState[globalIndex]}
                            onChange={() => handleCheckboxChange(globalIndex)}
                            className="w-5 h-5 accent-purple-600"
                        />
                        </div>
                        <div className="flex flex-col gap-1">
                            <span className="font-semibold text-xl text-purple-800/90">
                            {s.criteria}
                            </span>
                            <span className="font-semibold text-md text-gray-800/100">
                            {s.description}
                            </span>
                        </div>
                        
                    </label>

                    <div className="w-full h-[2px] bg-purple-300 mx-auto mt-2" />
                    {errors[globalIndex] && (
                        <p className="text-red-500 text-sm mt-1 ml-8">
                            {errors[globalIndex]}
                        </p>
                    )}
                    {/* Conditional Radios */}
                    {checkedState[globalIndex] && (
                        <div className="mt-2 mb-4 flex gap-4 ml-8">
                        {/* Effectiveness */}
                        <div>
                            <span className="font-semibold text-lg text-purple-700">
                            Level: How effective is this barrier?
                            </span>
                            <MitigationEffectRadio
                                list={effectiveness}
                                groupName={`effectiveness-${globalIndex}`}
                                value={radioState[`effectiveness-${globalIndex}`]}
                                onChange={(val) =>
                                handleRadioChange(`effectiveness-${globalIndex}`, val)
                            }
                            />
                            
                        </div>

                        {/* Confidence */}
                        <div>
                            <span className="font-semibold text-lg text-purple-700">
                            Confidence: How sure are you?
                            </span>
                            <MitigationEffectRadio
                                list={confidence}
                                groupName={`confidence-${globalIndex}`}
                                value={radioState[`confidence-${globalIndex}`]}
                                onChange={(val) =>
                                handleRadioChange(`confidence-${globalIndex}`, val)
                                }
                            />
                            
                        </div>
                        </div>
                    )}
                    </div>
                );
                })}
               

            </div>

        {/* Slide Controls */}
            <div className="flex justify-between items-center mt-4">
                <button
                onClick={() => {
                    if (validatePage()) {
                    setCurrentPage((prev) => Math.max(prev - 1, 0))
                    }
                }}
                className="px-4 py-2 bg-purple-600 text-white rounded disabled:opacity-40"
                disabled={currentPage === 0}
                >
                &#8592;
                </button>

                <span className="text-purple-700 font-semibold">
                Page {currentPage + 1} / {totalPages}
                </span>

                {currentPage === totalPages - 1 ? (
                <button
                onClick={() => submitMitigationEffectHandler()}
                className="px-4 py-2 bg-green-600 text-white rounded"
                >
                Submit
                </button>
            ) : (
                <button
                onClick={() => {
                    if (validatePage()) {
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
                    }
                }}
                className="px-4 py-2 bg-purple-600 text-white rounded disabled:opacity-40"
                disabled={currentPage === totalPages - 1}
                >
                &#8594;
                </button>
            )}
            </div>
    </div>
    );


}

export default MitigationModalContent